// TODO this file could go into lib/services
//  - but do we want the analytics package as a peerDep there?
//  - is this really ever used as it is?

import {
  addAdditionalServicesEvent,
  AdditionalServicesEvent,
  addTravelDetailsEvent,
  CheckoutFailedEvent,
  checkoutFailedEvent,
  checkoutFinishedEvent,
  checkoutStartedEvent,
  checkoutStepEvent,
  itemDetailEvent,
  itemListEvent,
  LoggerFactory,
  routeChangeEvent,
  TravelDetailsEvent
} from '@ibe/services';
import { tracking, trackingService } from './setup';
import { productItemListEvent, TrackingEvents } from './events';
import { ApiBestPricePackageModel } from '@ibe/api';

const logger = LoggerFactory.get('TrackingSubscriptions');

const trackingSubscriptions = (): void => {
  routeChangeEvent.subscribe(() => {
    logger.log('routeChangeEvent');
    tracking.page();
  });

  itemListEvent.subscribe(payload => {
    logger.log('packageItemListEvent', payload);
    trackingService.trackPackageListView(
      payload.items as ApiBestPricePackageModel[],
      'view_item_list'
    );
  });

  productItemListEvent.subscribe(payload => {
    logger.log('productItemListEvent', payload);
    trackingService.trackProductListView(payload, 'view_item_list');
  });

  itemDetailEvent.subscribe(payload => {
    logger.log('itemDetailEvent', payload);
    trackingService.trackItem(payload.item, TrackingEvents.VIEW_ITEM);
  });

  checkoutStartedEvent.subscribe(payload => {
    logger.log('beginCheckoutEvent', payload);
    trackingService.beginCheckout(payload.booking);
  });

  checkoutStepEvent.subscribe(payload => {
    logger.log('checkoutStepEvent', payload);
    trackingService.checkoutStep(payload.step, payload.booking);
  });

  addTravelDetailsEvent.subscribe((payload: TravelDetailsEvent) => {
    logger.log('addTravelDetailsEvent', payload);
    trackingService.addTravelDetails(payload, payload.step);
  });

  addAdditionalServicesEvent.subscribe((payload: AdditionalServicesEvent) => {
    logger.log('addAdditionalServicesEvent', payload);
    trackingService.additionalServices(
      payload.service_type,
      payload.service_name,
      payload.additional_service,
      payload.remove,
      payload.booking
    );
  });

  checkoutFinishedEvent.subscribe(payload => {
    logger.log('purchaseEvent', payload);
    trackingService.purchase(payload.booking);
  });

  checkoutFailedEvent.subscribe((payload: CheckoutFailedEvent) => {
    logger.log('checkoutFailedEvent', payload);
    trackingService.failedCheckout(payload.packageItem, payload.numberOfPersons);
  });
};
export default trackingSubscriptions;
